<template>
  <v-layout paypal-wrapper column justify-end>
    <div class="pt-2 text-center">
      <img src="/img/service-logo-pink.svg" alt="[Service Logo]" class="service-logo" />
    </div>

    <router-view></router-view>
  </v-layout>
</template>

<script>
export default {};
</script>

<style scoped>
.service-logo {
  height: 40px;
}
.paypal-wrapper {
  color: #676767;
  height: 100vh;
}
</style>
